const darkRed = {
  10: '#47232F',
  50: '#672636',
  100: '#872A3C',
  200: '#B63047',
}

export default darkRed
